import { type FC, type ReactNode } from "react";

// A tinted bar across the top of a pane while it's in a mode of its own (e.g.
// editing his template), with the way back on the right.
export const ModeBanner: FC<{ children: ReactNode; action: ReactNode }> = ({
  children,
  action,
}) => (
  <div className="flex items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3.5 py-2 text-[13px] font-medium text-amber-900">
    <div className="min-w-0 flex-1">{children}</div>
    <div className="shrink-0">{action}</div>
  </div>
);
